import React from 'react';
import LogoDesignHero from '../components/LogoDesignHero';
import Counters from '../components/Counters';
import ProfessionalLogoDesigns from '../components/ProfessionalLogoDesigns';
import LogoServicesTabs from '../components/LogoServicesTabs';
import LogoPortfolioSlider from '../components/LogoPortfolioSlider';
import LogoDesignProcess from '../components/LogoDesignProcess';
import LogoBrandingSolutions from '../components/LogoBrandingSolutions';
import TrustedLogoAgency from '../components/TrustedLogoAgency';
import ContactUs from '../components/ContactUs';

const designersIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.41 3.59 8 8 8h1a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h1c4.41 0 8-3.59 8-8 0-5.52-4.48-10-10-10z" />
    <circle cx="7.5" cy="11.5" r="1.5" fill="#c40a0a" />
    <circle cx="10.5" cy="7.5" r="1.5" fill="#c40a0a" />
    <circle cx="15.5" cy="7.5" r="1.5" fill="#c40a0a" />
    <circle cx="18.5" cy="11.5" r="1.5" fill="#c40a0a" />
  </svg>
);

const projectsIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

const experienceIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);

const satisfactionIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
);

const logoCountersData = [
  { target: 10, suffix: '+', text: 'Designers', icon: designersIcon },
  { target: 400, suffix: '+', text: 'Projects Completed', icon: projectsIcon },
  { target: 9, suffix: '+', text: 'Years of Experience', icon: experienceIcon },
  { target: 100, suffix: '%', text: 'Client Satisfaction', icon: satisfactionIcon }
];

function LogoDesignPage({ setView }) {
  return (
    <>
      <LogoDesignHero />
      <Counters data={logoCountersData} />
      <ProfessionalLogoDesigns />
      <LogoServicesTabs />
      <LogoPortfolioSlider />
      <LogoDesignProcess />
      <LogoBrandingSolutions setView={setView} />
      <TrustedLogoAgency setView={setView} />
      <ContactUs />
    </>
  );
}

export default LogoDesignPage;
